import React from 'react'

import FeedItem from 'js/components/FeedItem/FeedItem'
import FeedItemContent from 'js/components/FeedItem/FeedItemContent'

const Card = ({ 'data-feed': dataFeed, entity }) => {
    return (
        <FeedItem data-feed={dataFeed}>
            <FeedItemContent entity={entity} />
        </FeedItem>
    )
}

export default Card
